module.exports = __webpack_public_path__ + "img/zhuyili3.477f2b14.png";